import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      // Пункты, которые НЕ показываем. take() убирает элемент из меню
      // (если id не найден — вернёт null, ничего не сломается).
      nav.take('page:search'); // вместо страницы — модалка поиска выше

      // Ниже — разделы, за которыми сейчас пусто. Пункт меню, ведущий на пустую
      // страницу, читается как «портал недонастроен», поэтому их не показываем.
      // Возвращать по мере появления содержимого:
      nav.take('page:techdocs'); // вернуть, когда mkdocs.yml будет минимум в 3 репо
      nav.take('page:api-docs'); // вернуть, когда появится первая сущность kind: API
      nav.take('page:kubernetes'); // k8s у нас нет вовсе (в логах — warning о missing config)

      // ⚠ Уведомления рисуются отдельным элементом внизу (NotificationsSidebarItem),
      // поэтому из общего списка их надо забрать — иначе пункт двоится в меню.
      nav.take('page:notifications');

      // Отдельная страница графа: она строит граф ТОЛЬКО вокруг корневой сущности,
      // а из меню открывается без корня — всегда пустой холст с фильтрами.
      // Задать корень конфигом расширения не вышло: page:catalog-graph игнорирует
      // свои пропсы (проверено — maxDepth из конфига не доезжает, поле остаётся
      // «Infinite», хотя выключения расширений из того же блока конфига работают).
      // Граф при этом никуда не делся: карточка «Relations» есть на каждой сущности,
      // и её ссылка «View graph →» открывает ту же страницу уже с корнем.
      nav.take('page:catalog-graph');

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {nav.take('page:catalog')}
            {nav.take('page:scaffolder')}
            <SidebarDivider />
            <SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <NotificationsSidebarItem />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:app-visualizer')}
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
